/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Process_FreeInputs */

const en_failed_to_process_free = /** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to process free listing.`)
};

const es_failed_to_process_free = /** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al procesar el anuncio gratuito.`)
};

const fr_failed_to_process_free = /** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du traitement de l'annonce gratuite.`)
};

const de_failed_to_process_free = /** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler bei der Verarbeitung des kostenlosen Inserats.`)
};

const id_failed_to_process_free = /** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal memproses listing gratis.`)
};

/** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */
const ja_failed_to_process_free = en_failed_to_process_free;

/** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */
const zh_failed_to_process_free = en_failed_to_process_free;

/** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */
const ar_failed_to_process_free = en_failed_to_process_free;

/** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */
const it_failed_to_process_free = en_failed_to_process_free;

/** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */
const ru_failed_to_process_free = en_failed_to_process_free;

/** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */
const pt_failed_to_process_free = en_failed_to_process_free;

/** @type {(inputs: Failed_To_Process_FreeInputs) => LocalizedString} */
const ko_failed_to_process_free = en_failed_to_process_free;

/**
* | output |
* | --- |
* | "Failed to process free listing." |
*
* @param {Failed_To_Process_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const failed_to_process_free = /** @type {((inputs?: Failed_To_Process_FreeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Process_FreeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failed_to_process_free(inputs)
	if (locale === "es") return es_failed_to_process_free(inputs)
	if (locale === "fr") return fr_failed_to_process_free(inputs)
	if (locale === "de") return de_failed_to_process_free(inputs)
	if (locale === "ja") return ja_failed_to_process_free(inputs)
	if (locale === "zh") return zh_failed_to_process_free(inputs)
	if (locale === "ar") return ar_failed_to_process_free(inputs)
	if (locale === "id") return id_failed_to_process_free(inputs)
	if (locale === "it") return it_failed_to_process_free(inputs)
	if (locale === "ru") return ru_failed_to_process_free(inputs)
	if (locale === "pt") return pt_failed_to_process_free(inputs)
	return ko_failed_to_process_free(inputs)
});